export default{
	name : 'traffic_dialog',
	props:{
		show : Boolean
	},
	data () {
		return {}
	},
	methods : {
		close() {
			this.$emit('close');
		},
		wfcx() {
			this.$router.push('/violation_inquiry');
		},
		kczp() {
			window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3duserid%26redirect%3dpolice.kczp%26type%3dparams%26params%3dopenId&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
        },
		wfjk() {
			window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3duserid%26redirect%3dpolice.wfjk%26type%3dnone&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
		},
		cjgyw() {
			window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3duserid%26redirect%3dpolice.cjgyw%26type%3dnone&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
		},
		batrcl() {
			window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3duserid%26redirect%3dpolice.batrcl%26type%3dnone&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/traffic_dialog/traffic_dialog.controller.js